var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === _vm.ActivityTypes.USER_STATUS_CHANGED.id
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" local_cafe ")])
    : _vm.type === _vm.ActivityTypes.BLOCK_VISITOR.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" lock "),
      ])
    : _vm.type === _vm.ActivityTypes.UNBLOCK_VISITOR.id
    ? _c("span", { staticClass: "material-icons text-success" }, [
        _vm._v(" lock_open "),
      ])
    : _vm.type === _vm.ActivityTypes.VISITOR_TAG_ADDED.id
    ? _c("span", { staticClass: "material-icons text-success" }, [
        _vm._v(" local_offer "),
      ])
    : _vm.type === _vm.ActivityTypes.VISITOR_TAG_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" local_offer "),
      ])
    : _vm.type === _vm.ActivityTypes.USER_ADDED.id
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" person_add ")])
    : _vm.type === _vm.ActivityTypes.CHANNEL_CREATED.id
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" add_box ")])
    : _vm.type === _vm.ActivityTypes.CHANNEL_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CHAT_OPENED.id
    ? _c("span", { staticClass: "material-icons" }, [_vm._v(" chat ")])
    : _vm.type === _vm.ActivityTypes.CHAT_CLOSED.id
    ? _c("span", { staticClass: "material-icons" }, [
        _vm._v(" mark_chat_read "),
      ])
    : _vm.type === _vm.ActivityTypes.WEBHOOK_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" webhook "),
      ])
    : _vm.type === _vm.ActivityTypes.WEBHOOK_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WEBHOOK_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v(" webhook "),
      ])
    : _vm.type === _vm.ActivityTypes.TRIGGER_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.TRIGGER_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TRIGGER_UPDATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.DEPARTMENT_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.DEPARTMENT_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.ROLE_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.ROLE_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" remove_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.TAGS_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.TAGS_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" remove_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.WELCOME_MESSAGE_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.WELCOME_MESSAGE_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.BANNED_WORD_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.BANNED_WORD_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_WORKFLOW_CREATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_UPDATE_PRIORITY.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("arrow_upload_ready"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_ADDED_TAGS.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [_vm._v(" style ")])
    : _vm.type === _vm.ActivityTypes.TASK_REMOVED_TAGS.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v(" style "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_UPDATE_TITLE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [_vm._v(" edit ")])
    : _vm.type === _vm.ActivityTypes.TASK_UPDATE_DESCRIPTION.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" description "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_UPDATE_START_DATE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [_vm._v(" event ")])
    : _vm.type === _vm.ActivityTypes.TASK_UPDATE_END_DATE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [_vm._v(" event ")])
    : _vm.type === _vm.ActivityTypes.TASK_UPDATE_OWNER.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" person "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_ADDED_FOLLOWERS.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" group_add "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_REMOVED_FOLLOWERS.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v(" group_remove "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_ADDED_COLLABORATORS.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" group_add "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_UPDATE_CHECKLIST.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" checklist "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_ADDED_SUBTASK.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_task "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_REMOVED_SUBTASK.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v(" remove_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_ADDED_ATTACHMENT.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" attach_file "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_COMPLETED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [_vm._v(" done ")])
    : _vm.type === _vm.ActivityTypes.TASK_ARCHIVED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" archive "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_RESTORED.id
    ? _c("span", { staticClass: "material-icons md-icon text-success" }, [
        _vm._v(" restore "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_UNARCHIVED.id
    ? _c("span", { staticClass: "material-icons md-icon text-success" }, [
        _vm._v(" unarchive "),
      ])
    : _vm.type === _vm.ActivityTypes.SETTINGS_UPDATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" settings "),
      ])
    : _vm.type === _vm.ActivityTypes.MAIL_ADDRESS_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.USER_ADDED_TO_DEPARTMENT.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.USER_REMOVED_FROM_DEPARTMENT.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CHANNEL_VISIBILITY_CHANGED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    update\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CHANNEL_FORWARD_CONFIG_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("\n    forward\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CHANNEL_ZOHO_CONFIG_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("\n    sync_alt\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTENT_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.CONTENT_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CUSTOMER_GROUP_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.CUSTOMER_GROUP_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CUSTOMER_GROUP_UPDATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.CHAT_ASSIGNED_TO_USER.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" maps_ugc "),
      ])
    : _vm.type === _vm.ActivityTypes.CHAT_FORWARDED_TO_USER.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    phone_forwarded\n"),
      ])
    : _vm.type === _vm.ActivityTypes.USER_JOINED_TO_CHAT.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" shortcut "),
      ])
    : _vm.type === _vm.ActivityTypes.USER_LOGGED_IN.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" login "),
      ])
    : _vm.type === _vm.ActivityTypes.TICKET_ASSIGNED_TO_USER.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    assignment_ind\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_CREATED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    cell_tower\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_CANCELED.id
    ? _c("span", { staticClass: "material-icons text-warning" }, [
        _vm._v("\n    cell_tower\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_COMPLETED.id
    ? _c("span", { staticClass: "material-icons text-success" }, [
        _vm._v("\n    cell_tower\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_FAILED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    cell_tower\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_WORKFLOW_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_WORKFLOW_RESTORED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("\n    restore\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_WORKFLOW_PERMANENTLY_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("\n    delete_forever\n"),
      ])
    : _vm.type === _vm.ActivityTypes.BILLING_ADDRESS_UPDATED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.INVOICE_CREATED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" cell_tower "),
      ])
    : _vm.type === _vm.ActivityTypes.PLAN_STARTED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" cell_tower "),
      ])
    : _vm.type === _vm.ActivityTypes.PLAN_CANCELED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" cell_tower "),
      ])
    : _vm.type === _vm.ActivityTypes.INVOICE_PAYMENT_RECEIVED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" paid "),
      ])
    : _vm.type === _vm.ActivityTypes.INVOICE_PAYMENT_FAILED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    money_off_csred\n"),
      ])
    : _vm.type === _vm.ActivityTypes.AUTO_REBALANCE_SUCCESS.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" money_off_csred "),
      ])
    : _vm.type === _vm.ActivityTypes.AUTO_REBALANCE_FAILED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" money_off_csred "),
      ])
    : _vm.type === _vm.ActivityTypes.AUTO_REBALANCE_DISABLED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" money_off_csred "),
      ])
    : _vm.type === _vm.ActivityTypes.PAYMENT_METHOD_ADDED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v(" add_card "),
      ])
    : _vm.type === _vm.ActivityTypes.INVOICE_REFUNDED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    assignment_return\n"),
      ])
    : _vm.type === _vm.ActivityTypes.LOGIN_FORM_ACTIVATED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    format_indent_decrease\n"),
      ])
    : _vm.type === _vm.ActivityTypes.LOGIN_FORM_DEACTIVATED.id
    ? _c("span", { staticClass: "material-icons text-dark" }, [
        _vm._v("\n    format_indent_increase\n"),
      ])
    : _vm.type === _vm.ActivityTypes.LOGIN_FORM_UPDATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.USER_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v(" remove_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_PROP_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon text-dark" }, [
        _vm._v("\n    add_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_PROP_REMOVED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_CREATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_circle "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_STAGE_CHANGED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_CREDIT_LOW.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" expand_more "),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_CREATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" smart_toy "),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_CREDIT_LOW.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" report "),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_CREDIT_DONE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" disc_full "),
      ])
    : _vm.type === _vm.ActivityTypes.AUTOMATION_TASK_CREDIT_LOW.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" warning "),
      ])
    : _vm.type === _vm.ActivityTypes.AUTOMATION_TASK_CREDIT_DONE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [_vm._v(" error ")])
    : _vm.type === _vm.ActivityTypes.SYSTEM_STATUS.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger" }, [
        _vm._v("\n    remove_circle\n"),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_RESTORED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("restore"),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_PUBLISHED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" public "),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_ASSIGNED_TO_USER.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v(" add_task "),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_V1_BOT_STATE_CHANGED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    qr_code_scanner\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WHATSAPP_V2_BOT_STATE_CHANGED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    qr_code_scanner\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WABA_SUPSIS_PARTNER_REMOVE.id ||
      _vm.type === _vm.ActivityTypes.WABA_SUPSIS_PARTNER_REMOVE_LEGACY.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    link_off\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WABA_SUPSIS_PARTNER_ADDED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    person_add\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WABA_SUPSIS_ACCOUNT_DELETED.id ||
      _vm.type === _vm.ActivityTypes.WABA_SUPSIS_ACCOUNT_DELETED_LEGACY.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    delete_forever\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WABA_SUPSIS_ACCOUNT_VIOLATION.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    warning\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WABA_SUPSIS_AD_ACCOUNT_LINKED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    link\n"),
      ])
    : _vm.type ===
      _vm.ActivityTypes.WABA_SUPSIS_AUTH_INTL_PRICE_ELIGIBILITY_UPDATE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    price_change\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WABA_SUPSIS_DISABLED_UPDATE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    block\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WABA_SUPSIS_MM_LITE_TERMS_SIGNED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    fact_check\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WABA_SUPSIS_PARTNER_APP_INSTALLED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    install_mobile\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WABA_SUPSIS_PARTNER_APP_UNINSTALLED.id
    ? _c("span", { staticClass: "material-icons md-icon text-danger" }, [
        _vm._v("\n    delete_forever\n"),
      ])
    : _vm.type ===
      _vm.ActivityTypes.WABA_SUPSIS_PARTNER_CLIENT_CERTIFICATION_STATUS_UPDATE
        .id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    verified_user\n"),
      ])
    : _vm.type ===
      _vm.ActivityTypes.WABA_SUPSIS_BUSINESS_PRIMARY_LOCATION_COUNTRY_UPDATE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    public\n"),
      ])
    : _vm.type ===
      _vm.ActivityTypes.WABA_SUPSIS_VOLUME_BASED_PRICING_TIER_UPDATE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    trending_up\n"),
      ])
    : _vm.type ===
      _vm.ActivityTypes.WABA_SUPSIS_MESSAGE_TEMPLATE_COMPONENTS_UPDATE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    article\n"),
      ])
    : _vm.type ===
      _vm.ActivityTypes.WABA_SUPSIS_MESSAGE_TEMPLATE_STATUS_UPDATE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    speed\n"),
      ])
    : _vm.type === _vm.ActivityTypes.WABA_SUPSIS_TEMPLATE_CATEGORY_UPDATE.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("\n    category\n"),
      ])
    : _vm.type === _vm.ActivityTypes.RESERVATION_CREATED_PLAN.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [_vm._v(" today ")])
    : _vm.type === _vm.ActivityTypes.RESERVATION_UPDATED_PLAN.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v("\n    event_repeat\n"),
      ])
    : _vm.type === _vm.ActivityTypes.RESERVATION_DELETED_PLAN.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v("\n    event_busy\n"),
      ])
    : _vm.type === _vm.ActivityTypes.RESERVATION_CREATED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [_vm._v(" today ")])
    : _vm.type === _vm.ActivityTypes.RESERVATION_UPDATED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" event_repeat "),
      ])
    : _vm.type === _vm.ActivityTypes.RESERVATION_DELETED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" event_busy "),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_OWNER_UPDATED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.WHITE_LIST_ADDED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.WHITE_LIST_REMOVED.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" update "),
      ])
    : _vm.type === _vm.ActivityTypes.AUTOMATION_CREATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [
        _vm._v("rocket_launch"),
      ])
    : _vm.type === _vm.ActivityTypes.AUTOMATION_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.AUTOMATION_RESTORED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("restore"),
      ])
    : _vm.type === _vm.ActivityTypes.AUTOMATION_PUBLISHED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("publish"),
      ])
    : _vm.type === _vm.ActivityTypes.AUTOMATION_UNPUBLISHED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("unpublished"),
      ])
    : _vm.type === _vm.ActivityTypes.AUTOMATION_UPDATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [_vm._v("edit")])
    : _vm.type === _vm.ActivityTypes.FORM_CREATED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("add_box"),
      ])
    : _vm.type === _vm.ActivityTypes.FORM_UPDATED.id
    ? _c("span", { staticClass: "material-icons md-icon" }, [_vm._v("edit")])
    : _vm.type === _vm.ActivityTypes.FORM_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.FORM_RESTORED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("restore"),
      ])
    : _vm.type === _vm.ActivityTypes.FORM_DOWNLOADED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("download"),
      ])
    : _vm.type === _vm.ActivityTypes.USER_ROLE_CHANGED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("admin_panel_settings"),
      ])
    : _vm.type === _vm.ActivityTypes.USER_PASSWORD_CHANGED.id
    ? _c("span", { staticClass: "material-icons text-primary md-icon" }, [
        _vm._v("lock_reset"),
      ])
    : _vm.type === _vm.ActivityTypes.USER_EMAIL_CHANGED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("email"),
      ])
    : _vm.type === _vm.ActivityTypes.USER_NAME_CHANGED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("badge"),
      ])
    : _vm.type === _vm.ActivityTypes.USER_PHONE_CHANGED.id
    ? _c("span", { staticClass: "material-icons text-secondary md-icon" }, [
        _vm._v("phone"),
      ])
    : _vm.type === _vm.ActivityTypes.USER_DISABLED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("block"),
      ])
    : _vm.type === _vm.ActivityTypes.ROLE_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-purple md-icon" }, [
        _vm._v("manage_accounts"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_WORKFLOW_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-teal md-icon" }, [
        _vm._v("account_tree"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_ADDED.id
    ? _c("span", { staticClass: "material-icons text-green md-icon" }, [
        _vm._v("add_box"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-blue md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.DRIVE_FOLDER_CREATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("create_new_folder"),
      ])
    : _vm.type === _vm.ActivityTypes.DRIVE_FOLDER_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("folder_delete"),
      ])
    : _vm.type === _vm.ActivityTypes.DRIVE_FOLDER_RENAMED.id
    ? _c("span", { staticClass: "material-icons text-blue md-icon" }, [
        _vm._v("drive_file_rename_outline"),
      ])
    : _vm.type === _vm.ActivityTypes.DRIVE_FILE_ADDED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("note_add"),
      ])
    : _vm.type === _vm.ActivityTypes.DRIVE_FILE_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete_outline"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_MODULE_RULES_ENABLED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("rule"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_MODULE_RULES_DISABLED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("rule"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_MODULE_RULES_RULE_ADDED.id
    ? _c("span", { staticClass: "material-icons text-primary md-icon" }, [
        _vm._v("add_circle"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_MODULE_RULES_RULE_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_MODULE_RULES_RULE_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_MODULE_RULES_RULE_ENABLED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("check_circle"),
      ])
    : _vm.type === _vm.ActivityTypes.TASK_MODULE_RULES_RULE_DISABLED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("cancel"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_MODULE_RULES_ENABLED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("check_circle"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_MODULE_RULES_DISABLED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("cancel"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_MODULE_RULES_RULE_ADDED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("add_circle"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_MODULE_RULES_RULE_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_MODULE_RULES_RULE_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_MODULE_RULES_RULE_ENABLED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("check_circle"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_MODULE_RULES_RULE_DISABLED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("cancel"),
      ])
    : _vm.type === _vm.ActivityTypes.DEVELOPER_TOKEN_CHANGED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("vpn_key"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_CREATED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("table_chart"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_RESTORED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("restore"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_PERMANENTLY_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete_forever"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_FIELD_ADDED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("add_box"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_FIELD_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_FIELD_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_VIEW_ADDED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("visibility"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_VIEW_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_VIEW_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_PAGE_ADDED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("note_add"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_PAGE_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_PAGE_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_WIDGET_ADDED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("widgets"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_WIDGET_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_WIDGET_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_PERMISSION_CHANGED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("lock"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_DATA_DOWNLOADED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("download"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_DATA_IMPORTED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("cloud_upload"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_DATA_BATCH_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("update"),
      ])
    : _vm.type === _vm.ActivityTypes.TABLE_DATA_BATCH_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete_sweep"),
      ])
    : _vm.type === _vm.ActivityTypes.CONTACT_BATCH_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("group"),
      ])
    : _vm.type === _vm.ActivityTypes.CHAT_DATA_DOWNLOADED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("download"),
      ])
    : _vm.type === _vm.ActivityTypes.WEB_APP_CREATED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("web"),
      ])
    : _vm.type === _vm.ActivityTypes.WEB_APP_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.WEB_APP_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.WEB_TAB_CREATED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("tab"),
      ])
    : _vm.type === _vm.ActivityTypes.WEB_TAB_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.WEB_TAB_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.MODULE_CREATED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("add_box"),
      ])
    : _vm.type === _vm.ActivityTypes.MODULE_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.MODULE_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("delete"),
      ])
    : _vm.type === _vm.ActivityTypes.RELATION_CREATED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("link"),
      ])
    : _vm.type === _vm.ActivityTypes.RELATION_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("edit"),
      ])
    : _vm.type === _vm.ActivityTypes.VOICE_AGENT_CREATED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("record_voice_over"),
      ])
    : _vm.type === _vm.ActivityTypes.VOICE_AGENT_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("record_voice_over"),
      ])
    : _vm.type === _vm.ActivityTypes.VOICE_AGENT_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("record_voice_over"),
      ])
    : _vm.type ===
      _vm.ActivityTypes.VOICE_AGENT_PHONE_NUMBER_INBOUND_AGENT_CHANGED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("phone"),
      ])
    : _vm.type ===
      _vm.ActivityTypes.VOICE_AGENT_PHONE_NUMBER_OUTBOUND_AGENT_CHANGED.id
    ? _c("span", { staticClass: "material-icons text-info md-icon" }, [
        _vm._v("phone"),
      ])
    : _vm.type === _vm.ActivityTypes.VOICE_AGENT_BATCH_CALL_CREATED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("call"),
      ])
    : _vm.type === _vm.ActivityTypes.VOICE_AGENT_KNOWLEDGE_BASE_CREATED.id
    ? _c("span", { staticClass: "material-icons text-success md-icon" }, [
        _vm._v("library_books"),
      ])
    : _vm.type === _vm.ActivityTypes.VOICE_AGENT_KNOWLEDGE_BASE_DELETED.id
    ? _c("span", { staticClass: "material-icons text-danger md-icon" }, [
        _vm._v("library_books"),
      ])
    : _vm.type === _vm.ActivityTypes.CHATBOT_AI_MODEL_UPDATED.id
    ? _c("span", { staticClass: "material-icons text-warning md-icon" }, [
        _vm._v("model_training"),
      ])
    : _vm.type === _vm.ActivityTypes.CUSTOM.id
    ? _c("span", { staticClass: "metarial-icons md-icon" }, [
        _vm._v(" message "),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }